<script>
  import Dummydata from "./register/Dummydata.svelte";
  import Slider from "./Slider.svelte";
  import Header from "./Header.svelte";
  import Footer from "./Footer.svelte";
  import { monitorAuthState } from "./scripts/firebase.js";
  import { appMode } from "./scripts/stores";

  monitorAuthState();

  $: console.log($appMode);
</script>

<main>
  <div class="outer-container">
    <div class="header">
      <Header />
    </div>
    <Slider />
    <!-- <Dummydata /> -->

    <div class="footer">
      <Footer />
    </div>
  </div>
</main>

<style>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
  }

  .outer-container {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    height: 100vh;
  }
</style>
